// src/lib/orderId.js

export function normId(x) {
  const s = (x ?? "").toString().trim();
  return s ? s : "";
}

/**
 * Unified orderId resolver (frontend).
 * - supports current formData shape + legacy keys
 * - supports API responses (r, out, saved...)
 */
export function getOrderId({ formData, propsOrderId, response, extra } = {}) {
  return normId(
    propsOrderId ||
      formData?.orderId ||
      formData?.currentOrderId ||
      formData?.zakazkaId ||
      formData?.objednavkaId ||
      formData?.meta?.orderId ||
      formData?.meta?.id ||
      response?.orderId ||
      response?.id ||
      response?.data?.orderId ||
      response?.data?.id ||
      response?.item?.orderId ||
      response?.item?.id ||
      extra?.orderId ||
      extra?.id
  );
}

/**
 * Use when you receive API response after save/create to normalize into {orderId}.
 */
export function extractOrderIdFromResponse(r) {
  return normId(
    r?.orderId || r?.id || r?.data?.orderId || r?.data?.id || r?.item?.orderId || r?.item?.id
  );
}
